<section class="text-center m-5">
	<div class="jumbotron jumbotron-fluid">
		<div class="container alert alert-info">
			@if (mobileType === "android") {
				<h1 class="display-4">Android Tablet Installation Instructions</h1>
				<div color="primary" class="android-prompt">
					<button mat-button (click)="installPwa()">Add to Home screen</button>
				</div>
			} @else if (mobileType === "ios") {
				<h1 class="display-4">iPad Installation Instructions</h1>
				<div class="ios-prompt">
					<p>
						To install this web app on your device tap the Menu button and
						then 'Add to Home screen' button
					</p>
					<div>
						<img src="./assets/img/ios-menu-btn.png" />
						<mat-icon>navigate_next</mat-icon>
						<img src="./assets/img/ios-add-btn.png" />
					</div>
				</div>
			} @else {
				<p class="lead">
					This page should be accessed via a tablet device to install the app.
				</p>
			}
		</div>
	</div>
</section>
